import { useCallback, useEffect, useState } from "react";
import { debounce } from "lodash";

const useSearch = (data, columns, onSearch, onChangePage) => {
  console.log(data);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [localSearch, setLocalSearch] = useState(true);

  useEffect(() => {
    if (!Array.isArray(data)) {
      setFilteredData([]);
      return;
    }

    if (!localSearch && onSearch) {
      setFilteredData(data);
      return;
    }

    if (!searchQuery.trim()) {
      setFilteredData(data);
    } else {
      const filtered = data?.filter((row) => {
        return (
          String(row.active)
            .toLowerCase()
            .includes(searchQuery.toLowerCase()) ||
          String(row.approved)
            .toLowerCase()
            .includes(searchQuery.toLowerCase()) ||
          row.carType?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          row.driver?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          row.id?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          row.other_info?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          row.vehicleMake?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          row.vehicleModel?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          row.vehicleNumber?.toLowerCase().includes(searchQuery.toLowerCase())
        );
      });

      setFilteredData(filtered);
    }
  }, [data, searchQuery, localSearch, onSearch]);

  const debouncedSearch = useCallback(
    (query) => {
      const debouncedFn = debounce(() => {
        if (onSearch && !localSearch) {
          onSearch(query);
        }
      }, 500);
      debouncedFn();
    },
    [onSearch, localSearch]
  );

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (onSearch && !localSearch) {
      debouncedSearch(query);
    }
    if (onChangePage) onChangePage(0);
  };

  const handleClearSearch = () => {
    setSearchQuery("");
    if (onSearch && !localSearch) {
      onSearch("");
    }
    if (onChangePage) onChangePage(0);
  };
  return {
    searchQuery,
    filteredData,
    handleClearSearch,
    handleSearchChange,
    setLocalSearch,
  };
};

export default useSearch;
